import { Component, OnInit, Input, Output, ContentChildren, ElementRef, EventEmitter, QueryList } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CfCoreComponent } from '../core/core.component';
import { CfFormQuestionComponent } from '../form-question/form-question.component';
import { FormQuestionControlService } from '../../services/form-generator/form-question-control.service';
import { GroupQuestionModel } from '../../models/group/group-question.model';
import { GroupQuestionStylingModel } from '../../models/group/group-question-styling.model';
import { GroupQuestionTemplates } from '../../templates/group-question.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Group Question Component</p>
 * <pre>
 * <code>
 * import {{'{'}} GroupQuestionModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} GroupQuestionStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-group-question<code>></code><code><</code><code>/</code>cf-group-question<code>></code>
 * </code>
 * </pre>
 */
export class CfGroupQuestionComponent extends CfCoreComponent implements OnInit {
/**
 * <p>Example:</p>
 * <code><pre>{
 *  questions: this.myQuestions,
 *  key: 'person',
 *  payload: this.person,
 *  submitButton: {{'{'}} label: 'Save' {{'}'}}
 * }</pre></code>
 * <h4>questions: array</h4>
 * Array with questions.
 * <h4>key: string</h4>
 * Form key
 * <h4>payload: any</h4>
 * Data to be patched into form.
 * <h4>submitButton: ButtonModel</h4>
 * Form submit button
 */
public properties: GroupQuestionModel;
/**
 * <p>Styling object:</p>
 * <h4>container: StylingModel</h4>
 * Styling properties for main container
 * <h4>table: StylingModel</h4>
 * Styling for the group table
 * <h4>content: StylingModel</h4>
 * Styling for the content
 */
public styling: GroupQuestionStylingModel;
/**
 * Group's key
 * @param {?} value
 * @return {?}
 */
set key(value: string) { this.properties.key = value; }
/**
 * Array with group questions
 * @param {?} value
 * @return {?}
 */
set questions(value: GroupQuestionModel[]) { this.properties.questions = value; }
/**
 * @hidden
 */
formQuestions: QueryList<CfFormQuestionComponent>;
/**
 * @hidden
 */
groupQuestions: QueryList<CfGroupQuestionComponent>;
/**
 * @hidden
 */
form: any;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 * @param {?} fqcs
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService,
private fqcs: FormQuestionControlService) {
    super(elementRef, templateService);
    this.properties = new GroupQuestionModel();
    this.styling = new GroupQuestionStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    super.ngOnInit();
    this.getMyTemplate('group-question', GroupQuestionTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'GROUP-QUESTION').then(sampler => {
        // console.log('GROUP-QUESTION', this);
      });
    });
  }
/**
 * @hidden
 * @return {?}
 */
ngAfterContentInit() {
    if (this.formQuestions != null && this.formQuestions.length > 0 || this.groupQuestions != null && this.groupQuestions.length > 0) {
      let /** @type {?} */ manualQuestions = [];
      if (this.formQuestions != null && this.formQuestions.length > 0) {
        this.formQuestions.toArray().forEach((control, index) => manualQuestions.push(control.properties));
      }
      this.form = this.fqcs.toFormGroup(manualQuestions);
      if (this.groupQuestions != null && this.groupQuestions.length > 0) {
        this.groupQuestions.toArray().forEach((group, index) => {
          if (group.properties.key !== this.properties.key) {
            if (group.properties.key == null) { group.properties.key = 'group' + index; }
            this.form.addControl(group.properties.key, group.form);
          }
        });
        this.groupQuestions.toArray().forEach((group, index) => {
          if (group.properties.key !== this.properties.key) { group.form = this.form.controls[group.properties.key]; }
        });
      }
      if (this.formQuestions != null && this.formQuestions.length > 0) {
        this.formQuestions.toArray().forEach((control, index) => control.form = this.form);
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-group-question',
  template: "<div *ngIf=\"_inited && properties?.display\" [formGroup]=\"form\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-group-question-container'\"> <div *ngIf=\"(properties?.questions && properties?.questions?.length>0) || properties?.questions==null\" [formGroupName]=\"properties?.key\"> <table class=\"{{activeTemplate.style?.table?.class}} {{styling?.table?.class}} {{getDynamicClasses(activeTemplate.style?.table?.dynamicClass)}} {{getDynamicClasses(styling?.table?.dynamicClass)}}\" [ngClass]=\"'cf-group-question-table'\"> <ng-template let-question ngFor [ngForOf]=\"properties?.questions\"> <tr *ngIf=\"question?.properties?.questions && question?.properties?.questions?.length>0\" [formGroup]=\"form?.controls[properties?.key]\"><pre>im-group-question</pre> <cf-group-question [properties]=\"question\" [form]=\"form?.controls[properties?.key]\"></cf-group-question> </tr> <td *ngIf=\"question?.properties?.questions==null\"><pre>im-form-question</pre> <cf-form-question [question]=\"question\" [form]=\"form?.controls[properties?.key]\"></cf-form-question> </td> </ng-template> </table> </div> <div class=\"{{activeTemplate.style?.content?.class}} {{styling?.content?.class}} {{getDynamicClasses(activeTemplate.style?.content?.dynamicClass)}} {{getDynamicClasses(styling?.content?.dynamicClass)}}\" [ngClass]=\"'cf-group-question-content'\"><ng-content></ng-content></div> </div>",
  styles: [":host { width: 100%; } table { width: 100%; border-collapse: separate; border-spacing: 10px; } "],
  providers: [FormQuestionControlService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
{type: FormQuestionControlService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'key': [{ type: Input, args: ['key', ] },],
'questions': [{ type: Input, args: ['questions', ] },],
'formQuestions': [{ type: ContentChildren, args: [CfFormQuestionComponent, ] },],
'groupQuestions': [{ type: ContentChildren, args: [CfGroupQuestionComponent, ] },],
'form': [{ type: Input },],
};
}

function CfGroupQuestionComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfGroupQuestionComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfGroupQuestionComponent.ctorParameters;
/** @type {?} */
CfGroupQuestionComponent.propDecorators;
/**
 * <p>Example:</p>
 * <code><pre>{
 *  questions: this.myQuestions,
 *  key: 'person',
 *  payload: this.person,
 *  submitButton: {{'{'}} label: 'Save' {{'}'}}
 * }</pre></code>
 * <h4>questions: array</h4>
 * Array with questions.
 * <h4>key: string</h4>
 * Form key
 * <h4>payload: any</h4>
 * Data to be patched into form.
 * <h4>submitButton: ButtonModel</h4>
 * Form submit button
 * @type {?}
 */
CfGroupQuestionComponent.prototype.properties;
/**
 * <p>Styling object:</p>
 * <h4>container: StylingModel</h4>
 * Styling properties for main container
 * <h4>table: StylingModel</h4>
 * Styling for the group table
 * <h4>content: StylingModel</h4>
 * Styling for the content
 * @type {?}
 */
CfGroupQuestionComponent.prototype.styling;
/**
 * @hidden
 * @type {?}
 */
CfGroupQuestionComponent.prototype.formQuestions;
/**
 * @hidden
 * @type {?}
 */
CfGroupQuestionComponent.prototype.groupQuestions;
/**
 * @hidden
 * @type {?}
 */
CfGroupQuestionComponent.prototype.form;
/** @type {?} */
CfGroupQuestionComponent.prototype.elementRef;
/** @type {?} */
CfGroupQuestionComponent.prototype.fqcs;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
